import moment from 'moment';

export default function calculDaysBetweenTwoDate(dateDepart, dateFin) {
  return moment.duration(moment(dateDepart).diff(moment(dateFin))).asDays().toFixed(0);
}
